import React from "react";
import styled from "styled-components";
import Skeleton from "common/NewLook/Skeleton.tsx";
import { getNewLookTokens } from "common/NewLook/tokens.ts";

interface TableSkeletonProps {
  rows?: number;
}

/**
 * New look: loading rows for a panel table - a name over a meta line on the
 * left and a figure on the right, 56px each (no spinner over an empty list).
 */
const TableSkeleton = ({ rows = 4 }: TableSkeletonProps) => (
  <Wrapper aria-busy={true}>
    {Array.from({ length: rows }, (_, index) => (
      <Row key={index}>
        <Names>
          <Skeleton width={140} height={12} />
          <Skeleton width={96} height={10} />
        </Names>
        <Skeleton width={110} height={12} />
        <Skeleton width={80} height={12} />
      </Row>
    ))}
  </Wrapper>
);

export default TableSkeleton;

const Wrapper = styled.div`
  text-align: left;
`;
const Row = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr) 160px 120px;
  align-items: center;
  gap: 24px;
  min-height: 60px;
  padding: 8px 20px;
  & + & {
    border-top: 1px solid ${(p) => getNewLookTokens(p.theme).hairline};
  }
`;
const Names = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;
